<template>
  <div class="body-container bzqy-page">
    <div class="head-box">
      <div>保障权益</div>
      <div>保障额度/详情</div>
    </div>
    <div class="box">
      <div class="name">{{productName}}</div>
      <ul>
        <li v-for="(bean,index) in mainDatas" :key="index" :class="{'active':bean.isShow}" @click="showDetail(bean)">
          <div class="label" v-html="bean.premiseAttribute"></div>
          <div class="text">{{bean.guaranteeMoney}}
            <!-- <i class="icon-zhankai"></i> -->
            <van-icon class="xlIcon" name="arrow-down" />
          </div>
          <div class="describe" v-html="bean.describe"></div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
//当前实例组件
export default {
  data: () => ({
    productName:"",
    mainDatas: [], //主数据
    idCard:""
  }),
  mounted() {
    this.productName = this.$route.query.productName;
    this.idCard = this.$route.query.idCard;
    this.getDatas();
    document.documentElement.scrollTop = 0;
  },
  methods: {
    showDetail(item) {
      if (!item.describe) return;
      this.$set(item,"isShow",!item.isShow)
    },
    getDatas() {
      // 获取页面数据
      if (sessionStorage.jzy_bzqy) {
        const data = JSON.parse(sessionStorage.jzy_bzqy);
        this.mainDatas = data.filter((item)=>{
          return !item.insuresCardNo||item.insuresCardNo==this.idCard||!this.idCard;
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./bzqy.scss"
</style>
